export default "__VITE_ASSET__ZTTKdWv7__"